import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Joyride from 'react-joyride';
import {useQuery} from '@apollo/client';
import Query, {Loading} from '../../components/Query';
import {QUERY_LESSON_LIST} from './graphql';
import {QUERY_STUDY_LIST} from '../Study/graphql';
import {QUERY_USER} from '../Client/graphql';
import Icon from '../../components/Icon';
import {isActive, isLimited} from '../Client/utils';
import LessonPlan from './Plan';
import LessonHow from './How';
import {locale} from "../../utils/joyride";

const LessonList = () => {
  const [steps, setSteps] = useState([]);
  const [howIsOpen, setHowOpen] = useState(false);
  const [showInfo, setShowInfo] = useState(false);

  const {user} = useQuery(QUERY_USER).data;
  const [kind, setKind] = useState('list');

  const lessonQuery = useQuery(QUERY_LESSON_LIST);
  const list = lessonQuery.data ? lessonQuery.data.lessonList : [];

  const studyQuery = useQuery(QUERY_STUDY_LIST);
  const studies = studyQuery.data ? studyQuery.data.studyList : [];
  const lesson_ids = studies.map(x => x.lessonId);

  useEffect(() => {
    if (studies.length && list.length) {
      const study0 = studies.find(x => x.lesson.level === 0);
      if (study0.phoneticsPassed && study0.vocabularyPassed && study0.trialPassed && study0.finalPassed) {
        if (!localStorage.getItem('tourFinished@quiz-client')) {
          localStorage.setItem('tourFinished@quiz-client', true);
          setSteps([
            {
              target: '.list-group-item-first',
              content: 'Рядом с Уроком 0 появилась галочка, это означает что урок пройден. Для прохождения каждого урока нужно пройти все три элемента. Теперь вы можете переходить к основным урокам',
              disableBeacon: true,
              disableCloseOnEsc: true,
            },
          ]);
        }
      } else {
        setShowInfo(true);
        setSteps([
          {
            target: '.alert.alert-info',
            content: 'Добро пожаловать на наш сайт!',
            disableBeacon: true,
            disableCloseOnEsc: true,
          },
          {
            target: '.list-group-item-first',
            content: 'Сначала посмотрим как пользоваться сайтом. Нажмите на Урок: Вступление',
            disableBeacon: true,
            disableCloseOnEsc: true,
          },
        ]);
      }
    }
  }, [studies.length, list.length]);

  const currentLevel = user.client.currentLevel;
  const rem = currentLevel % 5;
  const lastLevel = rem ? currentLevel + (5 - rem) : currentLevel;

  return (
    <div className="LessonList">
      <Joyride steps={steps} run={!!steps.length} locale={locale} scrollOffset={80} />
      {/*{!!alert && (*/}
      {/*  <div className="alert alert-info position-relative text-center mt-3">*/}
      {/*    <div>Подсказка для режима</div>*/}
      {/*    <button*/}
      {/*      onClick={() => {*/}
      {/*        localStorage.setItem('alert@quiz-client', '0');*/}
      {/*        setAlert(0);*/}
      {/*      }}*/}
      {/*      className="btn btn-sm btn-light mt-3"*/}
      {/*    >*/}
      {/*      Понятно! Больше не показывать*/}
      {/*    </button>*/}
      {/*    <button*/}
      {/*      onClick={() => setAlert(false)}*/}
      {/*      className="position-absolute btn py-1 px-2"*/}
      {/*      style={{top: 0, right: 0}}*/}
      {/*    >*/}
      {/*      <Icon name="times" />*/}
      {/*    </button>*/}
      {/*  </div>*/}
      {/*)}*/}
      <div className="mt-4 col-12 col-lg-9 col-xl-6 mx-auto position-relative row justify-content-center align-items-center">
        <div
          className="position-relative flex-column justify-content-center align-items-center col-auto text-center"
          role="group"
        >
          <button
            onClick={() => setKind('list')}
            className={`d-block btn btn-lg btn${kind !== 'list' ? '-outline' : ''}-primary`}
          >
            Уроки
          </button>
          <button
            onClick={() => setKind('plan')}
            style={{left: '-75px', top: '5px'}}
            className={`d-block position-absolute btn btn-sm mt-1 btn${kind !== 'plan' ? '-outline' : ''}-primary my-other-step`}
          >
            Древо
          </button>
        </div>
        <div className="col-auto ms-4 position-absolute end-0">
          <button
            className="btn btn-sm btn-light text-primary px-3 py-1 border border-primary rounded-pill"
            onClick={() => setHowOpen(true)}
          >
            {/* <Icon name="question-circle" size={30} /> */}
            <span>Помощь</span>
          </button>
        </div>
      </div>
      {!isActive(user) && (
        <div className="alert alert-warning p-3 mt-4 mb-4">
          <div className="row justify-content-center align-items-center">
            <div className="col-auto text-center ms-1">
              {user.client.activeTill ? 'Активация вашего аккаунта просрочена.' : ''} Первые 10 уроков пробные. Для их
              прохождения активация не требуется
            </div>
            <div className="col-auto">
              <Link to="/payments" className="btn btn-link p-0 ms-2">
                Активировать
              </Link>
            </div>
          </div>
        </div>
      )}
      {kind === 'list' ? (
        <div>
          {showInfo && (
            <div className="alert alert-info text-center mt-4">
              <div>
                {/* <span>Добро пожаловать на наш сайт! </span> */}
                <span>Здесь то, что вы искали.</span>
                <br />
                Вся грамматика казахского языка. Более 1000 новых слов и 1500 заданий
              </div>
              {/* <button
                onClick={() => {
                  setShowInfo(false);
                  localStorage.setItem('alertedLessonList@quiz-client', true);
                }}
                type="button"
                className="btn btn-light btn-sm mt-2"
              >
                <span>Закрыть</span>
              </button> */}
            </div>
          )}
          {Query(lessonQuery) || (
            <ul className="list-group col-lg-9 col-xl-6 mx-auto py-4">
              {list.map((item, item_i) => {
                const idx = lesson_ids.indexOf(item.id);
                const study = idx !== -1 ? studies[idx] : {};
                const {vocabularyPassed, trialPassed, finalPassed, phoneticsPassed} = study;
                const isPassed = vocabularyPassed && trialPassed && finalPassed && phoneticsPassed;

                return (
                  <>
                    <Link
                      to={'/my-lessons/' + item.id + '/grammar'}
                      key={item.id}
                      className={`list-group-item ${item_i === 0 ? 'list-group-item-first' : ''} list-group-item-action`}
                    >
                      <div className="row justify-content-between align-items-center">
                        <span className="col">{'Урок ' + item.level + '. ' + item.name}</span>
                        <div className="col-auto">{isPassed && <Icon name="check" color="success" />}</div>
                      </div>
                    </Link>
                    {(() => {
                      if (item.level !== 0 && item.level % 5 === 0 && studyQuery.data) {
                        const study1 = studies.find(x => x.lessonId === list[item_i - 4].id) || {};
                        const study2 = studies.find(x => x.lessonId === list[item_i - 3].id) || {};
                        const study3 = studies.find(x => x.lessonId === list[item_i - 2].id) || {};
                        const study4 = studies.find(x => x.lessonId === list[item_i - 1].id) || {};

                        const isIntermediatePassed =
                          study.intermediatePassed &&
                          study1.intermediatePassed &&
                          study2.intermediatePassed &&
                          study3.intermediatePassed &&
                          study4.intermediatePassed;

                        const studyPassed =
                          study.isFinalPassed &&
                          study.trialPassed &&
                          study.finalPassed &&
                          study.vocabularyPassed &&
                          study.phoneticsPassed;

                        const study1Passed =
                          study1.isFinalPassed &&
                          study1.trialPassed &&
                          study1.finalPassed &&
                          study1.vocabularyPassed &&
                          study1.phoneticsPassed;

                        const study2Passed =
                          study2.isFinalPassed &&
                          study2.trialPassed &&
                          study2.finalPassed &&
                          study2.vocabularyPassed &&
                          study2.phoneticsPassed;

                        const study3Passed =
                          study3.isFinalPassed &&
                          study3.trialPassed &&
                          study3.finalPassed &&
                          study3.vocabularyPassed &&
                          study3.phoneticsPassed;

                        const study4Passed =
                          study4.isFinalPassed &&
                          study4.trialPassed &&
                          study4.finalPassed &&
                          study4.vocabularyPassed &&
                          study4.phoneticsPassed;

                        // if (
                        //   user.client.currentLevel > item.level ||
                        //   (user.client.currentLevel === item.level && user.client.isRepeat)
                        // ) {

                        // if (studyPassed && study1Passed && study2Passed && study3Passed && study4Passed) {
                        return (
                          <Link
                            to={`/intermediate/${item.level / 5}`}
                            className="list-group-item list-group-item-action"
                          >
                            <div className="row justify-content-between align-items-center text-uppercase">
                              <div className="col-auto">{'Тест повторение №' + item.level / 5}</div>
                              <div className="col-auto">
                                {isIntermediatePassed && <Icon name="check" color="success" />}
                              </div>
                            </div>
                          </Link>
                        );
                        // }
                        // }

                        return (
                          <div className="list-group-item text-secondary cursor-not-allowed">
                            <div className="row justify-content-between align-items-center text-uppercase">
                              <div className="col">{'Тест повторение №' + item.level / 5}</div>
                              <div className="col-auto">
                                <Icon name="lock" />
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return null;
                    })()}
                  </>
                );
              })}
            </ul>
          )}
        </div>
      ) : (
        <LessonPlan />
      )}
      <LessonHow isOpen={howIsOpen} onClose={() => setHowOpen(false)} />
    </div>
  );
};

export default LessonList;
